import React from 'react';
import PropTypes from 'prop-types';
import { Button, ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import { Form, Text } from 'react-form';
import { errorFor } from '../../utils/form';

const ResetPasswordForm = ({ loading, onSubmit, validate }) => (
  <Form onSubmit={onSubmit} validate={validate}>
    {formApi => {
      const usernameError = errorFor(formApi, 'username');
      const passwordError = errorFor(formApi, 'password');
      const password2Error = errorFor(formApi, 'password2');

      return (
        <form
          className="tvt-reset-password__form"
          onSubmit={formApi.submitForm}
        >
          <FormGroup
            validationState={usernameError ? 'error' : null}
            controlId="username"
          >
            <ControlLabel className="tvt-forgot-password__input-label">
              Username
            </ControlLabel>
            <Text
              className="form-control tvt-forgot-password__input"
              id="username"
              field="username"
              type="text"
            />
            <HelpBlock>{usernameError}</HelpBlock>
          </FormGroup>
          <FormGroup
            validationState={passwordError ? 'error' : null}
            controlId="password"
          >
            <ControlLabel className="tvt-reset-password__input-label">
              Choose a new password
            </ControlLabel>
            <Text
              className="form-control tvt-reset-password__input"
              id="password"
              field="password"
              type="password"
            />
            <HelpBlock>{passwordError}</HelpBlock>
          </FormGroup>

          <FormGroup
            validationState={password2Error ? 'error' : null}
            controlId="password2"
          >
            <ControlLabel className="tvt-reset-password__input-label">
              Repeat password
            </ControlLabel>
            <Text
              className="form-control tvt-reset-password__input"
              id="password2"
              field="password2"
              type="password"
            />
            <HelpBlock>{password2Error}</HelpBlock>
          </FormGroup>
          {loading && (
            <Button
              className="tvt-reset-password__submit"
              type="button"
              disabled
            >
              Loading...
            </Button>
          )}
          {!loading && (
            <Button className="tvt-reset-password__submit" type="submit">
              Save
            </Button>
          )}
        </form>
      );
    }}
  </Form>
);

ResetPasswordForm.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func
};

ResetPasswordForm.defaultProps = {
  loading: false,
  validate: () => {}
};

export default ResetPasswordForm;
